import React from 'react'
import HeroSection from '../HeroSection/HeroSection'
import busdIcon from "../../asstes/busd-icon.png"
import tvImg from "../../asstes/tv.webp"
import RecentActivity from '../RecentActivity/RecentActivity';
import { TiUserAddOutline } from "react-icons/ti";
import { BsArrowUpRightSquare } from "react-icons/bs";
import { IoWallet } from "react-icons/io5";
import DeskTopView from '../DeskTopView/DeskTopView';
import FaqSection from '../FaqSection/FaqSection';
import ForsageFooter from '../ForsageFooter/ForsageFooter';
import forsageFooterLogo from "../../asstes/logo_grey.png"
import { FaThumbsUp } from "react-icons/fa";
const Home = () => {
  const userItems = [
    {
      busdIcon: busdIcon, userIcon: <TiUserAddOutline size={35} className=' p-2 bg-[#444] rounded-full' />,
      user: "New user joined",
      userId: "ID 1700760",
      usedPrice: "",
      arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
    },
    {
      busdIcon: busdIcon, userIcon: <IoWallet size={35} className='text-green-500 bg-green  p-2 bg-green-900 rounded-full' />,
      user: "",
      userId: "ID 1413461", arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
      usedPrice: "+ 5 BUSD in ",
      subText: "x4"
    },
    {
      busdIcon: busdIcon, userIcon: <TiUserAddOutline size={35} className=' p-2 bg-[#444] rounded-full' />,
      user: "New user joined",
      userId: "ID 1700760",
      usedPrice: "",
      arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
    },
    {
      busdIcon: busdIcon, userIcon: <IoWallet size={35} className='text-green-500 bg-green  p-2 bg-green-900 rounded-full' />,
      user: "",
      userId: "ID 1413461", arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
      usedPrice: "+ 5 BUSD in ",
      subText: "x4"
    },

    {
      busdIcon: busdIcon, userIcon: <TiUserAddOutline size={35} className=' p-2 bg-[#444] rounded-full' />,
      user: "New user joined",
      userId: "ID 1700760",
      usedPrice: "",
      arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
    },
    {
      busdIcon: busdIcon, userIcon: <IoWallet size={35} className='text-green-500 bg-green  p-2 bg-green-900 rounded-full' />,
      user: "",
      userId: "ID 1413461", arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
      usedPrice: "+ 5 BUSD in ",
      subText: "x4"
    },
    {
      busdIcon: busdIcon, userIcon: <TiUserAddOutline size={35} className=' p-2 bg-[#444] rounded-full' />,
      user: "New user joined",
      userId: "ID 1700760",
      usedPrice: "",
      arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
    },
    {
      busdIcon: busdIcon, userIcon: <IoWallet size={35} className='text-green-500 bg-green  p-2 bg-green-900 rounded-full' />,
      user: "",
      userId: "ID 1413461", arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
      usedPrice: "+ 5 BUSD in ",
      subText: "x4"
    },
    {
      busdIcon: busdIcon, userIcon: <IoWallet size={35} className='text-green-500 bg-green  p-2 bg-green-900 rounded-full' />,
      user: "",
      userId: "ID 1413461", arroIcons: <BsArrowUpRightSquare />,
      userTime: "2 minutes",
      usedPrice: "+ 5 BUSD in ",
      subText: "x4"
    },
  ]

  const totalItems = [
    { number: "3 225 959", subNum: "+682", account: "Accounts count" },
    { numbers: "1 466 051 272", subNumer: "+14 013", accountUsd: "Total result, USD" }
  ]

  const faqItems = [
    {
      id: 1,
      title: "Why is Forsage the best alternative to trading?",
      contant: " The cryptocurrency rate has no effect on the sustainability of the rewards.The minimum entry threshold is equal to just a couple of cups of coffee. There is no need to wait for payouts - funds come instantly to your wallet. Rewards always depend only on the actions of the participant. participant can receive the reward indefinitely, as long as he expands his team."
    },
    {
      id: 2,
      title: "Is Forsage safe?",
      contant: "The functioning of Forsage is fully blockchain-protected. Participant leaves no personal data and has only his cryptocurrency wallet address connected via WEB 3.0 technology as a login. The entire Forsage infrastructure is built on the operation of tamper-proof smart contracts, and the website is simply a projection of data from the blockchain. It makes no sense to hack into the website."
    },
    {
      id: 3,
      title: "How much does it cost to participate in Forsage BUSD?",
      contant: "The functioning of Forsage is fully blockchain-protected. Participant leaves no personal data and has only his cryptocurrency wallet address connected via WEB 3.0 technology as a login. The entire Forsage infrastructure is built on the operation of tamper-proof smart contracts, and the website is simply a projection of data from the blockchain. It makes no sense to hack into the website."
    },
    {
      id: 4,
      title: "Whate do I need to get started in Forsage BUSD?",
      contant: "No special knowledge is required. Every participant must have their own smartphone or laptop with an installed app (Trust Wallet, TokenPocket or MetaMask), which has a personal Smart Chain (BNB Chain) cryptocurrency wallet set up. To register, you need to have at least a minimum amount - 10 BUSD, and some BNB for a blockchain fee."
    },
    {
      id: 5,
      title: "How do I start?",
      contant: "The functioning of Forsage is fully blockchain-protected. Participant leaves no personal data and has only his cryptocurrency wallet address connected via WEB 3.0 technology as a login. The entire Forsage infrastructure is built on the operation of tamper-proof smart contracts, and the website is simply a projection of data from the blockchain. It makes no sense to hack into the website."
    },
    {
      id: 6,
      title: "Where will my profit come from?",
      contant: "The functioning of Forsage is fully blockchain-protected. Participant leaves no personal data and has only his cryptocurrency wallet address connected via WEB 3.0 technology as a login. The entire Forsage infrastructure is built on the operation of tamper-proof smart contracts, and the website is simply a projection of data from the blockchain. It makes no sense to hack into the website."
    },
    {
      id: 7,
      title: "What role do NFT tokens play in Forsage?",
      contant: "The functioning of Forsage is fully blockchain-protected. Participant leaves no personal data and has only his cryptocurrency wallet address connected via WEB 3.0 technology as a login. The entire Forsage infrastructure is built on the operation of tamper-proof smart contracts, and the website is simply a projection of data from the blockchain. It makes no sense to hack into the website."
    },
  ]

  const forsageFooterItems = [
    {
      logo: forsageFooterLogo, title: "The world's first 100% decentralized matrix platform",
      busd: "xXx busd",
      item: "0x2CAa...ae52",
      busdIcon: busdIcon,
      supportIcon: <FaThumbsUp size={25} />,
    }
  ]
  return (
    <>
      <div className='w-full min-h-screen bg-[#242526] py-10'>
        <div className='container mx-auto px-4  md:container md:mx-auto py-16 bg-gradient-to-t from-pink-500 to-purple-500'>
          <h1 className='text-white  text-5xl text-center font-bold py-4'>Convenient office</h1>
          <p className='text-gray-300 text-xl text-center'>Interactive online visualization of active slots showing your unique NFT collection and your
            <br /> financial progress.</p>
          <img className='mx-auto' src={tvImg} alt="tv-img" />
        </div>
        <HeroSection />
        <div className="">
          <div className='bg-gradient-to-b  md:container md:mx-auto from-pink-500 font-bold to-purple-500'>
            <h1 className='text-4xl md:text-5xl text-center text-white pt-8'>Platform recent activity</h1>
            <h3 className='text-slate-200 text-lg md:text-xl py-6 md:py-10 text-center'>Real-time global events of the FORSAGE Platform</h3>
            <div className='w-full mx-auto px-2 md:px-6 bg-[#333] py-5 rounded-lg'>
              {userItems.map((item, index) => (
                <RecentActivity key={index} item={item} />
              ))}
            </div>
            <div className='px-5 text-center mx-auto'>
              <h2 className='text-white  text-4xl md:text-5xl py-5 mt-8'>Partner results</h2>
              <h3 className='text-gray-300  text-lg md:text-xl'>All data is stored in the blockchain in the public domain and can be verified!</h3>
              <p className='text-gray-300  text-center md:text-lg'>Contract address <span className='font-bold text-white text-lg md:text-xl'>busd: </span>0x5acc84a3e955Bdd76467d3348077</p>
              <div className='w-full text-center py-5 '>
                <p className=' hover:bg-slate-300 mx-auto cursor-pointer w-36 md:w-40 rounded-[20px] py-2 px-6 md:px-8 text-black font-bold text-lg bg-white'>Total</p>
              </div>
            </div>
            <div className='flex flex-wrap justify-center items-center'>
              {totalItems.map((item, id) => (
                <div className='mx-auto mb-4 md:mb-0' key={id}>
                  <div>
                    <h1 className='text-white text-3xl md:text-4xl items-center flex gap-1 md:gap-2'>{item.number} <span className='text-base md:text-lg text-green-400'>{item.subNum}</span></h1>
                    <p className='text-sm md:text-base text-center text-gray-300'>{item.account}</p>
                  </div>
                  <div>
                    <h1 className='text-white text-3xl md:text-4xl items-center flex gap-1 md:gap-2'>{item.numbers} <span className='text-base md:text-lg text-green-400'>{item.subNumer}</span></h1>
                    <p className='text-sm md:text-base text-center text-gray-300'>{item.accountUsd}</p>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>

        <DeskTopView />
        <div className='py-8'>
          <p className='text-white text-4xl px-4 md:text-5xl font-bold md:text-center'>Frequently asked Questions</p>
          <FaqSection faqItems={faqItems} />
        </div>
        <div>
          <ForsageFooter item={forsageFooterItems} />
        </div>
        
      </div>

    </>
  )
}

export default Home